
<!-- 24844 -->
<div >
   
    <img style="height:32px;" class="chooseLang clicked"  src="{{langSelected.url}}" [matMenuTriggerFor]="menu" >

    <mat-menu #menu="matMenu" >
      
            <div class="pad5px cur" fxLayoutAlign="start center"  fxLayoutGap="10px" *ngFor="let lang of languages" (click)="chooseLanguage(lang.value)">
                <img style="height:32px;" class="chooseLang clicked"  src="{{lang.url}}" 
                angulartics2On="click" angularticsAction="selectLanguage" angularticsCategory="lang">
                <div class="font12" fxLayoutAlign="center center" >{{lang.translate|translate}}</div>
            </div> 
          
       
        
    </mat-menu>
</div>





